"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeURLParameters = removeURLParameters;
exports.refreshAccessToken = refreshAccessToken;
exports.login = login;
var axios_1 = __importDefault(require("axios"));
var configuration_1 = require("./configuration");
var urls_1 = require("./urls");
var utils_1 = require("./utils");
var flags_1 = require("./flags");
var logout_1 = require("./logout");
function removeURLParameters(url, parameter) {
    var urlParts = url.split("?");
    if (urlParts.length >= 2) {
        var pairs = urlParts[1].split(/[&;]/g);
        var query = pairs.filter(function (x) {
            var key = x.split("=")[0];
            return parameter !== key;
        });
        return urlParts[0] + (query.length === 0 ? "" : "?".concat(query.join("&")));
    }
    else {
        return url;
    }
}
function exchangeCodeForAccessToken(code, redirectUri) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (configuration_1.configuration.environment === "") {
                        throw new Error("configuration is not defined");
                    }
                    flags_1.flags.exchangeAccessTokenInProgress = true;
                    return [4 /*yield*/, (0, axios_1.default)({
                            method: "post",
                            url: "".concat(configuration_1.configuration.businessAppAuthenticationApi.host, "/v1/oauth/accesstoken"),
                            data: {
                                authorizationCode: code,
                                redirectUri: encodeURIComponent(redirectUri),
                            },
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json;charset=UTF-8",
                            },
                            withCredentials: true,
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.data || !response.data.accessToken) {
                        flags_1.flags.exchangeAccessTokenInProgress = false;
                        throw new Error("access token not found");
                    }
                    (0, utils_1.setAccessToken)(response.data.accessToken, response.data.accessTokenExpiresIn);
                    flags_1.flags.exchangeAccessTokenInProgress = false;
                    return [2 /*return*/];
            }
        });
    });
}
function refreshAccessToken() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (flags_1.flags.refreshAccessTokenInProgress && flags_1.flags.refreshAccessTokenPromise) {
                return [2 /*return*/, flags_1.flags.refreshAccessTokenPromise];
            }
            flags_1.flags.refreshAccessTokenInProgress = true;
            flags_1.flags.refreshAccessTokenPromise = (0, axios_1.default)({
                method: "post",
                url: "".concat(configuration_1.configuration.businessAppAuthenticationApi.host, "/v1/oauth/refresh"),
                data: {},
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                withCredentials: true,
            })
                .then(function (response) {
                if (!response || !response.data || !response.data.accessToken) {
                    throw new Error("Could not refresh access token");
                }
                (0, utils_1.setAccessToken)(response.data.accessToken, response.data.accessTokenExpiresIn);
                flags_1.flags.refreshAccessTokenInProgress = false;
                return response.data.accessToken;
            })
                .catch(function (error) {
                flags_1.flags.refreshAccessTokenInProgress = false;
                throw error;
            });
            return [2 /*return*/, flags_1.flags.refreshAccessTokenPromise];
        });
    });
}
function login(config) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, redirectUri, redirectUri, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    (0, configuration_1.setConfiguration)(config);
                    if (flags_1.flags.refreshAccessTokenInProgress) {
                        return [2 /*return*/];
                    }
                    queryParams = (0, urls_1.getQueryParams)(window.location.href);
                    if (!(queryParams.externalCode && (0, urls_1.hasMultipleCodes)(window.location.href))) return [3 /*break*/, 2];
                    redirectUri = (0, urls_1.createRedirectUriForExternalCode)(queryParams, window.location.href);
                    return [4 /*yield*/, exchangeCodeForAccessToken(queryParams.code, redirectUri)];
                case 1:
                    _a.sent();
                    window.location.href = redirectUri;
                    return [2 /*return*/];
                case 2:
                    if (!(queryParams.code && !queryParams.externalCode)) return [3 /*break*/, 4];
                    redirectUri = removeURLParameters(window.location.href, "code");
                    return [4 /*yield*/, exchangeCodeForAccessToken(queryParams.code, redirectUri)];
                case 3:
                    _a.sent();
                    window.location.href = removeURLParameters(redirectUri, "locale");
                    return [2 /*return*/];
                case 4:
                    if ((0, utils_1.hasAccessToken)()) {
                        return [2 /*return*/];
                    }
                    _a.label = 5;
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, refreshAccessToken()];
                case 6:
                    _a.sent();
                    return [2 /*return*/];
                case 7:
                    error_1 = _a.sent();
                    return [2 /*return*/, (0, logout_1.logout)()];
                case 8: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=login.js.map